import React from 'react'
import '../stylesheets/Footer.sass'
import Content from '../StaticContent.json'
import me from '../img/me-blacked.png'
import instagram from '../img/Instagram.png'
import mail from '../img/Mail.png'
import german from '../img/german.png'
import english from '../img/english.png'

class Footer extends React.Component {

	constructor (props) {
		super(props)
		this.state = {language: props.language}
		this.setLanguage = props.setLanguage
		this.showPopup = props.showPopup
	}

	componentWillReceiveProps (props) {
		this.setState({language: props.language})
	}

	render() {

		var content = this.state.language === "de" ? Content.de.footer : Content.en.footer

		return (
			<footer className="main">
			<div className="foreground">
			<div className="centered">
			<h2>{content[0]}</h2>
			<h3>{content[1]}</h3>
			</div>
			<div className="bottom">
			<div className="languages">
				<img id="de" src={german} alt="German Flag" onClick={this.setLang}/>
				<img id="en" src={english} alt="Brittish Flag" onClick={this.setLang}/>
			</div>
			<h4>{content[2]}</h4>
			<div>
				<img src={instagram} alt="Instagram Icon" onClick={() => {this.showPopup("instagram")}}/>
				<img src={mail} alt="Mail Icon" onClick={() => {this.showPopup("mail")}}/>
			</div>
			</div>
			</div>
			<div className="background">
			<div></div>
			<img src={me} alt="Tim Patrick Kakucs"/>
			</div>
			</footer>
			)
}

	setLang = (event) => {
		this.setLanguage(event.target.id)
	}

}

export default Footer